import { useMutation } from 'react-query';
import { setPatientPin } from '@higo/api/lib/services';
import { SetPinDTO } from '@higo/api/lib/models/setPinDTO';
import { useMicrositeApiContext } from 'contexts/MicrositeApiContext';

export const useSetPatientPinMutation = () => {
  const { baseAxios } = useMicrositeApiContext();

  return useMutation((dto: SetPinDTO) => setPatientPin(baseAxios)(dto), {
    onSuccess: () => {
      // toast.success(
      //   intl.formatMessage({
      //     id: 'authentication.setPinCode.successMessage',
      //   }),
      // );
    },
  });
};
